import React from "react";
import Header2 from "../../Components/header/Header2/Header2";
import Footer from "../../Components/Footer/Footer";
import MiniDrawer from "../../Components/sidebar/SideBar2";
import UOPTableCard from "../../Components/Card/UOPCards/UopTableCard";

import { Box, Stack, Paper, Divider, Typography, Button } from "@mui/material";
import { useSelector } from "react-redux";
import { SessionVerificationAdmin } from "../../Components/SessionManagement/SessionManagementAdmin";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";

const UOP = () => {
  const open = useSelector((state) => state.sideExpand.open);

  return (
    <>
      <SessionVerificationAdmin />
      <Header2 />
      <MiniDrawer />
      <Box
        sx={{
          marginLeft: {
            xs: 7,
            sm: 8,
          },
          ...(open && { marginLeft: 33 }),
          transition: "200ms",
          minHeight: "77vh",
        }}
      >
        <Stack direction="column" justifyContent="center" alignItems="center">
          <Paper
            sx={{
              width: "95%",
              //marginLeft: 2,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              //paddingLeft: 3,
              pb: 5,
            }}
            elevation={0}
          >
             <CardHeadMenu
                    prefix={""}
                    suffix={""}
                    title={"UNREGISTER PAYMENT"}
                    // handlePopup={handlePopup}
                    // isEdit={isEdit}
                    show={false}
                  />
            <Divider />
            <UOPTableCard />
          </Paper>
        </Stack>
      </Box>
    </>
  );
};
export default UOP;
